import React from 'react';
import { BoldHeader5Text, SmallBodyText } from 'ui-toolkit';
import { StyledSummaryItem } from './SummaryItem.styles';
import { useShouldSummaryItemRender } from '../useShouldSummaryItemRender';
import { LoadingSpinnerTW } from '../../../../tailwindComponents/loadingSpinnerTW/LoadingSpinnerTW';
import type { FCWithChildren } from '../../../../types/FCWithChildren';
import { Box } from '@zillow/constellation-10';

export interface ISummaryItemProps {
  label: string;
  tab?: string;
  isLoading?: boolean;
}

export const SummaryItem: FCWithChildren<ISummaryItemProps> = ({ children, label, isLoading, tab }) => {
  const shouldRender = useShouldSummaryItemRender(label, tab);
  if (!shouldRender) {
    return null;
  }
  return (
    <StyledSummaryItem>
      <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
        <BoldHeader5Text>{label}</BoldHeader5Text>
      </Box>
      <LoadingSpinnerTW isLoading={isLoading}>
        <SmallBodyText>{children}</SmallBodyText>
      </LoadingSpinnerTW>
    </StyledSummaryItem>
  );
};
